module.exports = __webpack_public_path__ + "img/styria-it.dc57a3e4.svg";